/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Cell, flexRender } from '@tanstack/react-table'
import clsx from 'clsx'
import { getTableColumnClassName, TableColumnMeta } from 'utils/table/tableColumnWidths'

interface UiTableCellItemProps {
    cell: Cell<any, any>
    decorationId: string
}

const UiTableCellItem: React.FC<UiTableCellItemProps> = ({ cell, decorationId }) => {
    return (
        <td
            className={clsx(
                'UiTableCellItem',
                cell.column.id !== 'actions' && cell.column.id !== 'select' && 'overflow-hidden',
                getTableColumnClassName(cell.column.columnDef.meta as TableColumnMeta | undefined, cell.column.id),
                cell.column.id === decorationId
                    ? 'relative'
                    : 'px-2 first:pl-4 last:pr-4 py-2.5 align-middle table-cell-tight'
            )}
        >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
    )
}

export default UiTableCellItem
